const wholeAmountFormatter = Intl
  ? new Intl.NumberFormat("en", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })
  : {
      format: (amount) => {
        let val = Math.round(amount);
        return val.toString();
      },
    };

const fractionalAmountFormatter = Intl
  ? new Intl.NumberFormat("en", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
  : {
      format: (amount) => {
        return amount.toFixed(2);
      },
    };

const formatAmount = (amount, { includeCurrency = true } = {}) => {
  if (amount == null) return null;
  amount =
    amount % 1 === 0
      ? wholeAmountFormatter.format(amount)
      : fractionalAmountFormatter.format(amount);
  if (includeCurrency) amount = `£${amount}`;
  return amount;
};

module.exports = formatAmount;
